import { IProcedure } from '../Procedure';
import { MetadataType } from './MetadataType';
import { IWidgetInput } from '../widget/input/WidgetInput';
import { IOutput } from '../output/Output';
import * as uuid from 'uuid';
import { ContextualValueType } from '../contextual-value/ContextualValue';
import { IWidget } from '../widget/Widget';
import { IWidgetDynamic } from '../widget/dynamic/WidgetDynamic';

export const UNLINK_METADATA = 'unlink';

export interface IMetadata {
  id: string;
  /** Etichetta del metadato */
  name: string;

  /** Codice che identifica il metadato in caso di metadati multipli dello stesso widget */
  code?: string;
  procedureId: number;
  procedure: IProcedure;
  datatype: MetadataType;
  input?: IWidgetInput;
  dynamic?: IWidgetDynamic;
  output?: IOutput;

  /** Valorizzazione automatica da metadato contestuale */
  contextual?: ContextualValueType;
  contextualEditable: boolean;

  // Frontend
  linkToOutputId?: string;
}

// Interfaccia per la creazione di un metadato con associato il widget di appartenenza
export interface IMetadataWithWidget {
  metadata: IMetadata;
  widget: IWidget;
}

export function createMetadata(
  name: string,
  datatype: MetadataType,
  code?: string
) {
  return {
    id: uuid.v4(),
    name,
    code,
    datatype
  } as IMetadata;
}

/**
 * Il nome viene calcolato dinamicamente in seguito
 */
export function partialMetadata(datatype: MetadataType, code?: string) {
  return {
    id: uuid.v4(),
    code,
    datatype
  } as IMetadata;
}
